








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BackButton extends Vue {
  @Prop()
  clickBack?: () => void;

  clickBtnBack() {
    if (this.clickBack){
      this.clickBack();
      return false;
    }

    window.history.back();
    // this.$router.go(-1);
    return false;
  }
}
